import { z } from "zod";

/**
 * DEPOLAMA MUTABAKATI KONFİGİ (CLOS-831 · CLOS-313).
 *
 * ⚠ Cron ifadesi — dakika sayısı DEĞİL. Dakika tabanlı bir ayarı koda gömüp ifadeye
 * çevirmek, 60'ın üstündeki her değeri sessizce yanlış sıklığa düşürüyor (cron'un dakika
 * alanı 0-59). Aynı hata CLOS-828'de yapıldı ve ölçülerek bulundu.
 */
export const storageConfigSchema = z.object({
  version: z.literal(1),
  reconciliation: z.object({
    cron: z.string().trim().min(9).max(64),
  }),
});

export type StorageConfig = z.infer<typeof storageConfigSchema>;
